"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styled = require("./styled.card");

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var Card = function Card(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props);
  var style = newProps.style,
      text = newProps.text;


  var styleCardProps = {
    background: getPropValue("text", "style-background", style.background, "style"),
    border: getPropValue("text", "border", style.border, "style"),
    color: getPropValue("text", "color", style.color, "style"),
    hoverColor: getPropValue("text", "hoverColor", style.hoverColor, "style"),
    fontSize: getPropValue("text", "fontSize", style.fontSize, "style"),
    textTransform: getPropValue("text", "textTransform", style.textTransform, "style")
  };

  var src = getPropValue("text", "srcURL", text.srcURL ? text.srcURL : _defaultProps2.default.props.text.srcURL, "text");
  var alt = getPropValue("text", "alt", text.alt, "text");
  var title = getPropValue("text", "title", text.title, "text");
  var price = getPropValue("text", "price", text.price, "text");
  var productURL = getPropValue("text", "productURL", text.productURL, "text");

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _styled.StyledCard,
      _extends({
        target: "_blank",
        className: "d-block position-relative product-image",
        href: productURL
      }, styleCardProps),
      _react2.default.createElement("img", { className: "d-block", src: src, alt: alt })
    ),
    _react2.default.createElement(
      _styled.Info,
      { className: "info d-block p-3" },
      _react2.default.createElement(
        "a",
        {
          href: productURL,
          className: "d-block mb-1 product-title",
          target: "_blank"
        },
        title
      ),
      _react2.default.createElement(
        "span",
        { className: "d-block price" },
        price,
        " "
      )
    )
  );
};
exports.default = Card;